import moment from 'moment'

export const dateFormatter = (params) => {
  const {value} = params
  if (!value) return '-'
  
  return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
}